import { render, staticRenderFns } from "./PriceIndex.vue?vue&type=template&id=32176921&scoped=true"
import script from "./PriceIndex.vue?vue&type=script&lang=js"
export * from "./PriceIndex.vue?vue&type=script&lang=js"
import style0 from "./PriceIndex.vue?vue&type=style&index=0&id=32176921&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32176921",
  null
  
)

export default component.exports